// src/api/api.js
import axios from "axios";
import i18n from "../../lang/i18n";

const BASE_URL = process.env.REACT_APP_API_BASE_URL_MAIN; 
const defaultHeaders = {
  "Content-Type": "application/json"
};

/**
 * Factory to create an axios instance with interceptors
 */
function createApi(baseURL) {
  const instance = axios.create({
    baseURL,
    headers: defaultHeaders,
  });

  // Request interceptor
  instance.interceptors.request.use(
    (config) => {
      const token =
        localStorage.getItem("authToken") || localStorage.getItem("token");
      if (token) {
        config.headers.Authorization = `Bearer ${token}`;
      }

      // Language header
      const currentLang =
      i18n.language || localStorage.getItem("i18nLng") || "fr";
      const langMap = { en: "us", us: "us", fr: "fr", es: "es" };
      config.headers["lang"] = langMap[currentLang] || "fr";

      return config;
    },
    (error) => Promise.reject(error)
  );

  // Response interceptor
  // instance.interceptors.response.use(
  //   (response) => response,
  //   (error) => {
  //     if (error.response?.status === 401) {
  //       alert("Unauthenticated. Please log in again.");
  //       localStorage.clear();
  //       window.location.href = "/";
  //     }
  //     return Promise.reject(error);
  //   }
  // );

  return instance;
}

// Export API instances
export const api = createApi(BASE_URL);